const VIEWS = new Set(["findings", "overview", "codebase", "compare", "changes", "activity", "settings", "risk", "timings", "guide"]);

/**
 * Parse the location hash for deep links. Supports `#view=compare&a=..&b=..`,
 * `#compare?a=..&b=..`, and legacy single pairs like `#snapshot=..` or `#change=..`.
 */
export function hashParams(): URLSearchParams {
  const raw = typeof location === "undefined" ? "" : location.hash.replace(/^#/, "");
  if (/[?&]/.test(raw)) return new URLSearchParams(raw.replace(/^[^?&]*\?/, ""));
  return new URLSearchParams(raw);
}

/** Which view a shareable hash opens, if any. Runs on load; in-session navigation dispatches events. */
export function hashView(): string | null {
  if (typeof location === "undefined") return null;
  const raw = location.hash.replace(/^#/, "");
  const head = raw.split(/[?&]/)[0] ?? "";
  if (VIEWS.has(head)) return head;
  if (head.startsWith("snapshot=")) return "codebase";
  if (head.startsWith("change=")) return "changes";
  const view = new URLSearchParams(raw).get("view") ?? hashParams().get("view");
  return view && VIEWS.has(view) ? view : null;
}
